<template>
  <input type="text" data-timepicker class="form-control mb-2" :value="value" :placeholder="placeholder || 'Saat Seçin'|trans">
</template>

<script>
  export default {
    props: ["value", "placeholder"],
    mounted() {
      let vm = this;

      vm.$nextTick(() => {
        $(vm.$el)
          .timepicker({
            timeFormat: 'HH:mm',
            interval: 10,
            minTime: '00:00',
            maxTime: '23:59',
            startTime: '00:00',
            dynamic: false,
            dropdown: true,
            scrollbar: true,
            zindex: 500,
            change: function (time) {
              let picker = $(this).timepicker();
              if (picker.hasOwnProperty('format')) {
                vm.$emit("input", picker.format(time));
              }
            }
          });
      })
    },
    destroyed: function () {
      $(this.$el).off().timepicker().destroy();
    }
  }
</script>
